// extracted by mini-css-extract-plugin
export default {"li":"NavigationDrawerItem_li__tP4bd","navlink":"NavigationDrawerItem_navlink__sU3By","navlink-active":"NavigationDrawerItem_navlink-active__rqCvj"};